import { render, staticRenderFns } from "./BANNERRICERCA.vue?vue&type=template&id=2491d045&scoped=true"
import script from "./BANNERRICERCA.vue?vue&type=script&lang=ts"
export * from "./BANNERRICERCA.vue?vue&type=script&lang=ts"
import style0 from "./BANNERRICERCA.vue?vue&type=style&index=0&id=2491d045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2491d045",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeIvgTheSkeleton: require('/usr/src/nuxt-app/components/home/ivg/TheSkeleton.vue').default,StaticTheMoreDetailsBtnPush: require('/usr/src/nuxt-app/components/static/TheMoreDetailsBtnPush.vue').default})
